<template>
  <page-loader v-if="loadingStatus == 'loading'" />
  <div v-else class="contain-section">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-7 col-xl-8">
        <div class="inner-box">
          <div class="banner-box">
            <img class="rounded-4" :src="overview && overview.image ? overview.image[0].url : ''" alt="Logo" />
          </div>
          <div class="inner-content">
            <h3>{{ overview ? overview.heading : "" }}</h3>
            <div class="odd-even-section">
              <div class="col-sm-12">
                <div class="row random-box odd">
                  <div class="col-sm-12 col-md-12 col-lg-8 random-parg">
                    <h4 class="text-start fs-3 sm-fs-4 fw-bold">
                      {{
                        overview?.recent_ancestry && overview.recent_ancestry.length > 0
                          ? overview.recent_ancestry[0].heading
                          : ""
                      }}
                    </h4>
                    <div v-html="overview?.recent_ancestry && overview.recent_ancestry.length > 0
                      ? overview.recent_ancestry[0].text
                      : ''
                      "></div>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-4 rand-img">
                    <img :src="overview?.recent_ancestry && overview.recent_ancestry.length > 0
                      ? overview.recent_ancestry[0].image[0].url
                      : ''
                      " alt="view" class="" />
                  </div>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="row random-box even">
                  <div class="col-sm-12 col-md-12 col-lg-4 rand-img">
                    <img :src="overview?.recent_ancestry && overview.recent_ancestry.length > 0
                      ? overview.recent_ancestry[1].image[0].url
                      : ''
                      " alt="view" class="" />
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-8 random-parg">
                    <h4 class="text-start fs-4 fw-bold">
                      {{
                        overview?.recent_ancestry && overview.recent_ancestry.length > 0
                          ? overview.recent_ancestry[1].heading
                          : ""
                      }}
                    </h4>
                    <div v-html="overview?.recent_ancestry && overview.recent_ancestry.length > 0
                      ? overview.recent_ancestry[1].text
                      : ''
                      "></div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="row random-box odd">
                  <div class="col-sm-12 col-md-12 col-lg-8 random-parg">
                    <h4 class="text-start fs-4 fw-bold">
                      {{
                        overview?.recent_ancestry && overview.recent_ancestry.length > 0
                          ? overview.recent_ancestry[2].heading
                          : ""
                      }}
                    </h4>
                    <div v-html="overview?.recent_ancestry && overview.recent_ancestry.length > 0
                      ? overview.recent_ancestry[2].text
                      : ''
                      "></div>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-4 rand-img">
                    <img :src="overview?.recent_ancestry && overview.recent_ancestry.length > 0
                      ? overview.recent_ancestry[2].image[0].url
                      : ''
                      " alt="view" class="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-5 col-xl-4">
        <div class="right-bar">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-6 mb-4 mb-sm-0">
                <router-link to="/ancestry/recent" class="no-underline">
                  <div class="custom-card">
                    <!-- <div class="col-sm-12">
                                      <img src="../../../assets/images/ancetry/regions.svg" alt="" class="img-fluid">
                                  </div> -->
                    <div class="col-sm-12 text-center">
                      <h3>{{ autosomalStore.regions.length }}</h3>
                      <label>Total Regions</label>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="col-sm-6">
                <router-link to="/ancestry/recent" class="no-underline">
                  <div class="custom-card">
                    <!-- <div class="col-sm-12">
                    <img
                      src="../../../assets/images/ancetry/regions.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div> -->
                    <div class="col-sm-12 text-center">
                      <h3>{{ autosomalStore.subregions.length }}</h3>
                      <label>Total Subregions</label>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="population-group">
            <h4>
              {{
                overview.right_section && overview.right_section.length > 0
                  ? overview.right_section[0].heading
                  : ""
              }}
            </h4>
            <div v-html="overview.right_section && overview.right_section.length > 0
              ? overview.right_section[0].text
              : ''
              "></div>
            <img :src="overview.right_section && overview.right_section.length > 0
              ? overview.right_section[0].main_image[0].url
              : ''
              " />
            <router-link to="/ancestry/recent" class="load-btn m-auto">{{
              overview.right_section && overview.right_section.length > 0
                ? overview.right_section[0].button_text
                : ""
            }}</router-link>
          </div>

          <div class="population-group">
            <h4>
              {{
                overview.right_section && overview.right_section.length > 0
                  ? overview.right_section[1].heading
                  : ""
              }}
            </h4>
            <div v-html="overview.right_section && overview.right_section.length > 0
              ? overview.right_section[1].text
              : ''
              "></div>
            <img :src="overview.right_section && overview.right_section.length > 0
              ? overview.right_section[1].main_image[0].url
              : ''
              " />
            <router-link to="/ancestry/versions" class="load-btn m-auto">{{
              overview.right_section && overview.right_section.length > 0
                ? overview.right_section[1].button_text
                : ""
            }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../../styles/pages/ancentry/recent-ancetry.scss";
import { ref, onMounted } from "vue";
import { getRecentOverview } from "@/services/ancestry";
import { useAutosomalStore } from "@/store/ancestry/autosomal";
export default {
  name: "Ancestry-Section",
  setup() {
    const loadingStatus = ref("loading");
    const overview = ref({});
    const autosomalStore = useAutosomalStore();
    onMounted(async () => {
      overview.value = await getRecentOverview();
      loadingStatus.value = "loaded";
    });
    return { loadingStatus, overview, autosomalStore };
  },
};
</script>
